module.exports = __webpack_public_path__ + "img/icon-pagination-left.09f17051.svg";